// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "conversation".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { conversationStatusValues, messagingPlatformValues } from '@borradh-workspace/labels';
/** Response atom for the "conversation" table (1:1 with a DB row, on the wire). */
export const conversationAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    metaAdsPageId: z.string().nullable(),
    whatsappAccountId: z.string().nullable(),
    externalUserId: z.string(),
    externalUserName: z.string().nullable(),
    externalUserAvatar: z.string().nullable(),
    platform: z.enum(messagingPlatformValues),
    status: z.enum(conversationStatusValues),
    metadata: z.unknown().nullable(),
    version: z.number(),
    assignedToId: z.string().nullable(),
    leadId: z.string().nullable(),
    locationId: z.string().nullable(),
    staffReadAt: z.string().datetime().nullable(),
    archivedAt: z.string().datetime().nullable(),
    lastMessageAt: z.string().datetime().nullable(),
    closedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=conversation.js.map